<template>
  <div>
    <vs-table
      no-data-text="Для начала работы добавьте сотрудника."
      :data="data"
    >
      <template slot="thead">
        <!-- <vs-th>Аватар</vs-th> -->
        <vs-th>Имя</vs-th>
        <vs-th>Действия</vs-th>
          <vs-th>Отображать на общей странице?</vs-th>
        <vs-th>ID</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr
          :data="tr"
          :key="indextr"
          v-for="(tr, indextr) in data"
          @click.native="openEditUserPage(tr.user.id)"
          class="employees-table-row"
        >
          <!-- <vs-td class="img-container">
          <img
            v-if="tr.user.avatar"
            :src="`${apiURL}/media${tr.user.avatar}`"
            class="product-img"
            width="75"
            alt="image"
          />
          <img
            v-else
            :src="require(`@/assets/images/portrait/small/avatar.svg`)"
            class="product-img"
            width="75"
          />
        </vs-td> -->
          <vs-td :data="tr.name">
            {{ tr.user.last_name }} {{ tr.user.first_name }}
          </vs-td>
          <vs-td>
            <div class="flex actions" style="margin: -8px 0;">
              <vs-chip
                color="primary"
                v-if="is_manager(tr.user.id)"
                >Менеджер заведения</vs-chip
              >
              &thinsp;
              <button
                class="icon-button"
                type="button"
                title="Редактировать данные"
                :aria-label="`Редактировать данные ${tr.user.last_name}`"
                @click.stop="openEditUserPage(tr.user.id)"
              >
                <KonturIcon name="PeopleOneEditIcon" size="24" />
              </button>
              &emsp;
              <button
                class="icon-button"
                type="button"
                title="Скачать QR"
                aria-label="Скачать QR"
                @click.stop="oneQrCode(tr.user.id)"
              >
                <KonturIcon name="NetDownloadIcon" size="24" />
              </button>
              &emsp;
              <button
                class="icon-button"
                type="button"
                title="Платёжная страница"
                aria-label="Платёжная страница"
                @click.stop="openPaymentPage(tr.user.id)"
              >
                <KonturIcon name="ArrowUiCornerOutUpRightIcon" size="24" />
              </button>
              &emsp;
              <button
                class="icon-button"
                type="button"
                title="Отвязать сотрудника"
                aria-label="Отвязать сотрудника"
                :disabled="is_manager(tr.user.id)"
                @click.stop.prevent="detachEmployee(tr.user)"
              >
                <KonturIcon name="PeopleOneXIcon" size="24" />
              </button>
            </div>
          </vs-td>
          <vs-td :data="tr.branch_page_show" >
            <div @click="checkBoxClick">
              <vs-checkbox disabled="true" v-model="tr.branch_page_show"></vs-checkbox>
            </div>
          </vs-td>
          <vs-td :data="tr.id">
            {{ tr.user.id }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <vs-popup
      title="Редактировать сотрудника"
      :active.sync="popupEditUser"
      class="edit-employee-popup"
    >
      <BranchEditEmployee :employee="selectedEmployee" :userForm="formEmployee" :formBank="formBank"/>
    </vs-popup>

    <vs-popup
      title="Назначить сотрудника менеджером"
      :active.sync="popupRaise"
    >
      <p>Передайте эту ссылку зарегистрированному сотруднику</p>
      <vs-input v-model="raiseToken" />
      <vs-button
        v-clipboard:copy="raiseToken"
        v-clipboard:success="onCopy"
        v-clipboard:error="onError"
      >
        Копировать
      </vs-button>
      <p classs="mt-2">Сотрудник-менеджер сможет видеть все транзакции, <br>
        а также добавлять сотрудников данного заведения</p>
    </vs-popup>
  </div>
</template>

<script>
import { BRANCH_EMPLOYEES_FETCH, EMPLOYEE_BRANCH_DETACH } from '@/store/action.types'
import KonturIcon from '@/components/KonturIcon'
import BranchEditEmployee from './BranchEditEmployee.vue'
import AuthService from '@/common/auth.service'
import { mapGetters } from 'vuex'
import { API_URL } from '@/common/config'

export default {
  name: 'BranchEmployeesTable',
  components: {
    KonturIcon,
    BranchEditEmployee
  },
  props: {
    data: {
      type: Array
    }
  },
  data() {
    return {
      popupEditUser: false,
      popupRaise: false,
      raiseToken: null,
      selectedEmployee: 0,
      formEmployee: {
        first_name: '',
        nickname: '',
        last_name: '',
        phone_number: '',
        email: '',
        public_phrase: ''
      },
      formBank: {
        exist: false,
        account_number: '',
        bik: '',
        account_name: ''
      }
    }
  },
  computed: {
    ...mapGetters(['currentBranch'])
  },
  methods: {
    async initBranchEmployees(id) {
      this.loaded = false
      this.$vs.loading()
      await this.$store.dispatch(BRANCH_EMPLOYEES_FETCH, id).then(() => {
        // this.users = this.currentBranchEmployees
        this.$vs.loading.close()
        this.loaded = true
      })
    },
    async openEditUserPage(id) {
      this.selectedEmployee = id
      this.formBank = {
        account_number: undefined,
        bik: undefined,
        account_name: undefined,
        exist: false
      }
      this.popupEditUser = true
      this.$vs.loading()
      await AuthService.getEmployeeData(id)
        .then(({
          data
        }) => {
          this.$km_track('Staff', 'Click', 'EditEmployee')
          this.$vs.loading.close()
          this.formEmployee = data.user
          this.formEmployee.phone_number = data.phone_number
          this.formEmployee.branch_page_show = data.branch_page_show
          if (data.user.bank_account) {
            this.formBank = data.user.bank_account
            this.formBank.exist = true
          }
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log(error)
        })
    },
    async oneQrCode(uid) {
      this.$km_track('Staff', 'Click', 'GetEmployeeQR')
      await AuthService.oneQrCode(uid)
    },
    openPaymentPage(id) {
      this.$km_track('Staff', 'Click', 'toPayPage')
      window.open(`${API_URL}/pay/${id}`, '_blank')
    },
    is_manager(id) {
      return this.currentBranch.manager
        ? id === this.currentBranch.manager.user.id
        : false
    },
    detachEmployee(user) {
      this.$km_track('Staff', 'Click', 'Delete')
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Отвязать сотрудника`,
        text: `Вы уверены, что хотите отвязать сотрудника "${
          user.first_name
        }" от заведения?`,
        acceptText: 'Отвязать',
        cancelText: 'Отмена',
        accept: this.acceptEmployeeDetach,
        cancel: this.cancelEmployeeDetach,
        parameters: [user]
      })
    },
    acceptEmployeeDetach: function(parameters) {
      this.$km_track('DeleteEmployee', 'Click', 'Delete')
      const user = parameters[0]
      this.$vs.loading()
      const payload = {
        id: user.id,
        name: user.first_name,
        notify: this.$vs.notify
      }
      this.$store.dispatch(EMPLOYEE_BRANCH_DETACH, payload).then(() => {
        this.$vs.loading.close()
      })
    },
    cancelEmployeeDetach() {
      this.$km_track('DeleteEmployee', 'Click', 'Cancel')
    },
    checkBoxClick() {
      this.$vs.notify({
        text: 'Изменить значение можно при редактировании сотрудника'
      })
    },
    onCopy() {
      this.$vs.notify({
        title: 'Успех!',
        text: 'Ссылка скопирована в буфер обмена'
      })
    },
    onError() {
      this.$vs.notify({
        title: 'Failed!',
        text: 'Error in copying text.'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/scss/vuesax/_variables.scss';

  .product-img {
    border-radius: 50%;
  }

  .icon-button {
    border: 0;
    padding: 0;
    background: none;
    cursor: pointer;
    color: transparent;
    color: rgba(0, 0, 0, .6);

    &:hover {
      color: $black;
    }
  }

  .employees-table-row {
    cursor: pointer;
    transition: none;
    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, .12);
    border-bottom: none;

    &:hover,
    &:focus-within {
      background: #F2F2F2;
      box-shadow: -#{$size-2} 0 0 0 #F2F2F2,
                   #{$size-1} 0 0 0 #F2F2F2;
      border-radius: $size-1;
      border-color: transparent;
    }
    &:hover + &,
    &:focus-within + & {
      box-shadow: none;
    }
  }
</style>
